import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { NotificationsService } from '../../services/notifications.service';
import { ProfileService } from '../../services/profile.service';
import { LoadDataService } from '../../services/load-data.service';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.page.html',
  styleUrls: ['./notifications.page.scss'],
})
export class NotificationsPage implements OnInit {

  loading = true;

  unReadNotifications = [];
  readNotifications = [];

  constructor(
    private profileService: ProfileService,
    private notificationsService: NotificationsService,
    private loadData: LoadDataService,
    private changeDetector: ChangeDetectorRef
  ) { }
  
  ngOnInit() {
    this.notificationsService.getNotificationCount$()
        .subscribe( (resp:any) => {
          console.log('recibeee', resp);
          this.getNotfications();
        })
  }
  ionViewWillEnter() {
    this.getNotfications();
  }

  getNotfications() {
    setTimeout(() => {
      this.notificationsService.getNotifications(this.profileService.profile.id )
      .subscribe( (resp: any) => {
        this.loadData.notificaciones = resp
        this.loadData.getUnReadNotificationsLength();
  
        this.unReadNotifications = this.loadData.notificaciones.filter( urn => !urn.isRead );
        this.readNotifications = this.loadData.notificaciones.filter( urn => urn.isRead );
  
        this.loading = false;
  
        this.changeDetector.detectChanges();
  
      })  
    }, 500);
    
  }

}
